module.exports = __webpack_public_path__ + "media/images/icons/google-sign-up-950b9818e4ff403f9b867b9e9ce53415.svg";